module.exports = __webpack_public_path__ + "static/img/default.214caf8f.svg";